import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=34009c4c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=34009c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34009c4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34009c4c')) {
      api.createRecord('34009c4c', component.options)
    } else {
      api.reload('34009c4c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=34009c4c&scoped=true&", function () {
      api.rerender('34009c4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24iEPK75OUbSs/JS/comp/SearchFilterTokens.vue"
export default component.exports